/**
 * Billing enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Subscription status labels
export const subscriptionStatusLabels = {
    active: 'Active',
    canceled: 'Canceled',
    incomplete: 'Incomplete',
    incomplete_expired: 'Incomplete Expired',
    past_due: 'Past Due',
    trialing: 'Trialing',
    unpaid: 'Unpaid',
    paused: 'Paused',
};
export const subscriptionStatusValues = Object.keys(subscriptionStatusLabels);
// Credit transaction type labels
export const creditTransactionTypeLabels = {
    subscription_refill: 'Subscription Refill',
    purchase: 'Purchase',
    usage: 'Usage',
    refund: 'Refund',
    adjustment: 'Adjustment',
};
export const creditTransactionTypeValues = Object.keys(creditTransactionTypeLabels);
// Credit channel labels
export const creditChannelLabels = {
    sms: 'SMS',
    email: 'Email',
    voice: 'Voice',
    whatsapp: 'WhatsApp',
};
export const creditChannelValues = Object.keys(creditChannelLabels);
// Invoice status labels
export const invoiceStatusLabels = {
    draft: 'Draft',
    open: 'Open',
    paid: 'Paid',
    void: 'Void',
    uncollectible: 'Uncollectible',
};
export const invoiceStatusValues = Object.keys(invoiceStatusLabels);
//# sourceMappingURL=billing.js.map